import { render, staticRenderFns } from "./Minichallenges.vue?vue&type=template&id=60f78317&"
import script from "./Minichallenges.vue?vue&type=script&lang=js&"
export * from "./Minichallenges.vue?vue&type=script&lang=js&"
import style0 from "./Minichallenges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports